import React from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import s from './Crm.module.scss';
import { iInteractionForm, eCrmInteractionType } from 'services/Crm/Crm.type';

const INTERACTION_TYPES: eCrmInteractionType[] = [
  'call',
  'email',
  'meeting',
  'note',
  'other',
];

interface CrmInteractionFormProps {
  prospectFileId: number;
  onSubmit: (data: iInteractionForm) => Promise<void>;
  onCancel: () => void;
}

function CrmInteractionForm({
  prospectFileId,
  onSubmit,
  onCancel,
}: CrmInteractionFormProps): JSX.Element {
  const { t } = useTranslation();

  const {
    register,
    handleSubmit,
    formState: { isSubmitting },
  } = useForm<iInteractionForm>({
    defaultValues: {
      prospect_file_id: prospectFileId,
      type: 'note',
      subject: '',
      content: '',
      interaction_date: new Date().toISOString().split('T')[0],
    },
  });

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className={s.formGrid}>
        <div className={s.formGroup}>
          <label className={s.formLabel}>
            {t('crm:interaction_type')}
            <span className={s.required}> *</span>
          </label>
          <select
            {...register('type', { required: true })}
            className={s.formSelect}
          >
            {INTERACTION_TYPES.map((type) => (
              <option key={type} value={type}>
                {t(`crm:type_${type}`)}
              </option>
            ))}
          </select>
        </div>
        <div className={s.formGroup}>
          <label className={s.formLabel}>
            {t('crm:interaction_date')}
            <span className={s.required}> *</span>
          </label>
          <input
            type="date"
            {...register('interaction_date', { required: true })}
            className={s.formInput}
          />
        </div>
        <div className={s.formGroupFull}>
          <label className={s.formLabel}>
            {t('crm:subject')}
            <span className={s.required}> *</span>
          </label>
          <input
            type="text"
            {...register('subject', { required: true })}
            className={s.formInput}
          />
        </div>
        <div className={s.formGroupFull}>
          <label className={s.formLabel}>{t('crm:content')}</label>
          <textarea
            {...register('content')}
            rows={3}
            className={s.formTextarea}
          />
        </div>
      </div>
      <div className={s.formActions}>
        <button type="submit" className={s.btnPrimary} disabled={isSubmitting}>
          {isSubmitting ? '...' : t('crm:save')}
        </button>
        <button type="button" className={s.btnLink} onClick={onCancel}>
          {t('crm:cancel')}
        </button>
      </div>
    </form>
  );
}

export default CrmInteractionForm;
